import DesignButton from 'components/button/DesignButton';
import axios from 'core/apis/itineraryViewer';
import useCountryContext from 'core/hooks/useCountryContext';
import fileDownload from 'js-file-download';
import qs from 'qs';
import { useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { toast } from 'react-toastify';

export interface ActivityFileExportProps {
  startDate: string;
  endDate: string;
  courierIds: number[];
  exportName: string;
  endpoint: string;
  fileName: string;
}

export function ActivityFileExport({
  startDate,
  endDate,
  courierIds,
  exportName,
  endpoint,
  fileName,
}: ActivityFileExportProps) {
  const [isButtonDisabled, setisButtonDisabled] = useState<boolean>(false);
  const auth = useAuth();
  const { countryContext } = useCountryContext();
  const queryString = qs.stringify(
    {
      startDate,
      endDate,
      courierIds,
    },
    {
      indices: false,
    },
  );

  const onDownloadClick = () => {
    axios
      .get(`${endpoint}?${queryString}`, {
        responseType: 'blob',
        headers: {
          Authorization: auth.user?.access_token
            ? `Bearer ${auth.user?.access_token}`
            : '',
          'X-Tenant-Country': countryContext ?? '',
        },
      })
      .then((res) => {
        fileDownload(res.data, fileName);
      })
      .catch(() => {
        setisButtonDisabled(false);
        toast.error('Unexpected error occured while downloading the file', {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
      });
  };

  return (
    <div className="mb-4">
      <DesignButton
        onClickHandler={onDownloadClick}
        disabled={isButtonDisabled}
        className="ml-2 w-1/6"
      >
        {exportName}
      </DesignButton>
    </div>
  );
}
